var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactMainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5714 8.17731V13.3273C19.5714 16.4073 17.8114 17.7273 15.1714 17.7273H6.38144C5.93144 17.7273 5.50144 17.6874 5.10144 17.5974C4.85144 17.5574 4.61145 17.4873 4.39145 17.4073C2.89145 16.8473 1.98145 15.5473 1.98145 13.3273V8.17731C1.98145 5.09731 3.74144 3.77734 6.38144 3.77734H15.1714C17.4114 3.77734 19.0214 4.72734 19.4514 6.89734C19.5214 7.29734 19.5714 7.70731 19.5714 8.17731Z",
    stroke: "#2A38A4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5725 11.1774V16.3275C22.5725 19.4075 20.8125 20.7274 18.1725 20.7274H9.38254C8.64254 20.7274 7.97255 20.6275 7.39255 20.4075C6.20255 19.9675 5.39254 19.0575 5.10254 17.5975C5.50254 17.6875 5.93254 17.7274 6.38254 17.7274H15.1725C17.8125 17.7274 19.5725 16.4075 19.5725 13.3275V8.17743C19.5725 7.70743 19.5325 7.28746 19.4525 6.89746C21.3525 7.29746 22.5725 8.63743 22.5725 11.1774Z",
    stroke: "#2A38A4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7699 13.3972C12.2279 13.3972 13.4099 12.2152 13.4099 10.7572C13.4099 9.29917 12.2279 8.11719 10.7699 8.11719C9.31187 8.11719 8.12988 9.29917 8.12988 10.7572C8.12988 12.2152 9.31187 13.3972 10.7699 13.3972Z",
    stroke: "#2A38A4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05151 8.55762V12.9576",
    stroke: "#2A38A4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4932 8.55762V12.9576",
    stroke: "#2A38A4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactMainIcon);
export default __webpack_public_path__ + "static/media/transactMainIcon.7385c8e7681370146362f28a803b35a9.svg";
export { ForwardRef as ReactComponent };